import { render, staticRenderFns } from "./ApproveSelector.vue?vue&type=template&id=001bc748&scoped=true"
import script from "./ApproveSelector.vue?vue&type=script&lang=js"
export * from "./ApproveSelector.vue?vue&type=script&lang=js"
import style0 from "./ApproveSelector.vue?vue&type=style&index=0&id=001bc748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001bc748",
  null
  
)

export default component.exports